import React from "react";
import "./styles.css";

const Title = ({ fixed, variant = "lg", children }) => {
  return (
    <div>
      <h1 className={`panel-title panel-title-fixed panel-title-${variant}`}>{children}</h1>
    </div>
  );
};

export default Title;